import type { HeroContent } from "../types";

export const hero: HeroContent = {
  newsbarAriaLabel: "Platform updates",
  newsLabel: "LAUNCH · 14 SEPTEMBER 2026",
  newsItems: [
    "UCloud AI goes live for all 25,000 users of the national research platform",
    "Your research is never training data. Every token computed in Denmark",
    "Leading open international models at launch. Danish models on the way",
    "Chat and OpenAI-compatible API, right inside your UCloud project",
    "Running on Bitten in Sønderborg – energy-efficient computing, heat recovery",
    "From login to first token in five minutes. Sovereign AI, one login away",
  ],
  eyebrowLead: "Introducing",
  eyebrowName: "UCloud AI",
  titleLead: "Sovereign AI for Danish",
  titleAccent: "research.",
  titleSub: "Your research is never training data.",
  subtitle:
    "Run large language models on your own data, inside your existing " +
    "UCloud project, with your university login. Every token is computed " +
    "in Denmark, and your data is never used for training.",
  ctaPrimary: "Try it",
  ctaSecondary: "Contact us",
  finePrint: "Running on Bitten, Sønderborg · open source (EUPL) · ISO/IEC 27001:2022",
  finePrintSecondary: "Option of scaling to the Gefion AI supercomputer",
};
